import { Reveal, ChapterLabel } from "./primitives";
import { REASONS } from "../../data/site";

export const WhyChooseUs = () => {
  return (
    <section
      data-testid="why-section"
      className="relative bg-[#121212] px-5 py-24 md:px-10 md:py-32"
    >
      <div className="mx-auto max-w-[1400px]">
        <ChapterLabel number="03" title="Perché scegliere noi" />

        <div className="grid grid-cols-1 gap-px border border-white/10 bg-white/10 sm:grid-cols-2 lg:grid-cols-4">
          {REASONS.map((r, i) => {
            const Icon = r.icon;
            return (
              <Reveal
                key={i}
                delay={i * 0.08}
                data-testid={`reason-card-${i}`}
                className="group relative bg-[#121212] p-8 transition-colors duration-300 hover:bg-[#1A1A1A]"
              >
                <div className="mb-6 flex h-14 w-14 items-center justify-center border border-white/10 transition-colors duration-300 group-hover:border-[#FF2A2A]">
                  <Icon
                    className="h-6 w-6 text-[#FF2A2A]"
                    strokeWidth={1.5}
                  />
                </div>
                <h3 className="mb-3 font-display text-xl font-semibold uppercase tracking-tight text-[#FAFAFA]">
                  {r.title}
                </h3>
                <p className="font-body text-sm leading-relaxed text-[#A1A1AA]">
                  {r.desc}
                </p>
              </Reveal>
            );
          })}
        </div>
      </div>
    </section>
  );
};
